/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ConfiguratorImport } from './routes/_configurator'
import { Route as ConfiguratorStep1Import } from './routes/_configurator/step-1'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const ConfiguratorRoute = ConfiguratorImport.update({
  id: '/_configurator',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const ConfiguratorStep1Route = ConfiguratorStep1Import.update({
  path: '/step-1',
  getParentRoute: () => ConfiguratorRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_configurator': {
      id: '/_configurator'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ConfiguratorImport
      parentRoute: typeof rootRoute
    }
    '/_configurator/step-1': {
      id: '/_configurator/step-1'
      path: '/step-1'
      fullPath: '/step-1'
      preLoaderRoute: typeof ConfiguratorStep1Import
      parentRoute: typeof ConfiguratorImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  ConfiguratorRoute: ConfiguratorRoute.addChildren({ ConfiguratorStep1Route }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_configurator"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_configurator": {
      "filePath": "_configurator.tsx",
      "children": [
        "/_configurator/step-1"
      ]
    },
    "/_configurator/step-1": {
      "filePath": "_configurator/step-1.tsx",
      "parent": "/_configurator"
    }
  }
}
ROUTE_MANIFEST_END */
